import { render, staticRenderFns } from "./TrendsTab.vue?vue&type=template&id=064348c2"
import script from "./TrendsTab.vue?vue&type=script&lang=ts"
export * from "./TrendsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports